import React from 'react'
import {Icon, IconFont} from '@influxdata/clockface'

interface Props {
  show: boolean
}

const NotificationFlag = ({show}: Props): JSX.Element => {
  return (
    <div className={`notification-flag ${show && 'show'}`}>
      <Icon glyph={IconFont.CheckMark_New} />
      Confirmation Successful!
    </div>
  )
}

export default NotificationFlag
